import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { ClinicalFeedbackConstants } from '@app/clinical-feedback/clinical-feedback-constants';
import moment from 'moment';
import { FormElementModel, SearchOrderResponse } from 'src/app/clinical-feedback/clinical-feedback.model';
import { CommonUtilities } from 'src/app/shared/common-utilities';

@Component({
    selector: 'app-patient-details-form',
    templateUrl: './patient-details-form.component.html',
    styleUrls: [],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PatientDetailsFormComponent implements OnInit {
    @Input()
    order: SearchOrderResponse | null = null;
    public formGroup!: UntypedFormGroup;
    formElementModels = {
        patientFirstName: new FormElementModel({
            id: 'patientFirstName',
            label: 'First Name'
        }),
        patientLastName: new FormElementModel({
            id: 'patientLastName',
            label: 'Last Name'
        }),
        patientBirthDate: new FormElementModel({
            id: 'patientBirthDate',
            label: 'Date of Birth'
        }),
        accessionNumber: new FormElementModel({
            id: 'accessionNumber',
            label: 'Accession Number'
        }),
        trimmedAccessionNumber: new FormElementModel({
            id: 'trimmedAccessionNumber',
            label: 'Accession Number'
        }),
        patientMrn: new FormElementModel({
            id: 'patientMrn',
            label: 'Patient MRN'
        }),
        modality: new FormElementModel({
            id: 'modality',
            label: 'Modality'
        }),
        studyType: new FormElementModel({
            id: 'studyType',
            label: 'Study Type',
            enableTooltip: true
        }),
        studyDate: new FormElementModel({
            id: 'studyDate',
            label: 'Date of Examination'
        }),
        urgency: new FormElementModel({
            id: 'urgency',
            label: 'Urgency'
        }),
        reportingRadiologist: new FormElementModel({
            id: 'reportingRadiologist',
            label: 'Reporting Radiologist'
        })
    };
    showImageAvailabilityRelatedMessage = false;

    constructor(public parent: FormGroupDirective, private readonly formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        const orderStudyDateTime = CommonUtilities.formatDateTime(this.order?.studyDate);
        this.formGroup = this.formBuilder.group({
            patientFirstName: [{ value: this.order?.patientFirstName, disabled: true }],
            patientLastName: [{ value: this.order?.patientLastName, disabled: true }],
            patientBirthDate: [
                {
                    value: CommonUtilities.formatDateTime(this.order?.patientBirthDate),
                    disabled: true
                }
            ],
            accessionNumber: [{ value: this.order?.accessionNumber, disabled: true }],
            trimmedAccessionNumber: [{ value: this.order?.trimmedAccessionNumber, disabled: true }],
            patientMrn: [{ value: this.order?.patientMrn, disabled: true }],
            modality: [{ value: this.order?.modality, disabled: true }],
            studyType: [{ value: this.order?.studyType, disabled: true }],
            studyDate: [
                {
                    value: orderStudyDateTime,
                    disabled: true
                }
            ],
            urgency: [{ value: this.order?.urgency, disabled: true }],
            reportingRadiologist: [{ value: this.order?.reportingRadiologist, disabled: true }]
        });

        this.parent.form.addControl('patientDetailsForm', this.formGroup);

        this.showImageAvailabilityRelatedMessage = moment(orderStudyDateTime, 'DD/MM/YYYY')
            .add(ClinicalFeedbackConstants.IMAGES_ARCHIVED_AFTER_DAYS, 'd')
            .isBefore(moment());
    }
}
